import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';

export interface PrintPositionItem {
  id?: number;
  position_type: 1 | 2;
  left: number;
  top: number;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

export async function getPrintPositions(tenant: string, clinicNumber: string): Promise<PrintPositionItem[]> {
  const res = await apiClient.get<ApiEnvelope<{ positions: PrintPositionItem[] }>>(
    clinicApiPath(tenant, clinicNumber, '/print-positions')
  );
  return res.data.data.positions;
}

export async function updatePrintPositions(
  tenant: string,
  clinicNumber: string,
  positions: PrintPositionItem[]
): Promise<void> {
  await apiClient.put(
    clinicApiPath(tenant, clinicNumber, '/print-positions'),
    { positions }
  );
}
